import styles from './BlikPage.module.scss'


export function CooldownButton(props) {

  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${sec.toString().padStart(2, "0")}`;
  };

  return (
    <div>
      <button
        className={styles.otpSubmitButton}
        onClick={props.onClick}
        disabled={props.timeLeft > 0}
      >
        Ponów próbę
        {props.timeLeft > 0 && (
          <div className={styles.buttonTimerText}>
            {formatTime(props.timeLeft)}
          </div>
        )}
      </button>
    </div>
  );
}
